import useIsDesktop from 'hooks/useIsDesktop';
import * as React from 'react';
import { Paper, Toolbar } from '@mui/material';
import HeaderMobile from './HeaderMobile';
import HeaderDesktop from './HeaderDesktop';
import { HeaderElements } from './constants';

function Header(props) {
  const isDesktop = useIsDesktop();
  return (
    <Paper
      color="transparent"
      elevation={0}
      sx={{
        borderTop: 'none',
        borderRadius: 0,
        border: 'none',
        height: '100%',
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          height: '100%',
          width: '100%',
          px: {
            xs: 2,
            md: 4,
          },
        }}
      >
        {!isDesktop ? <HeaderMobile {...props} /> : <HeaderDesktop {...props} />}
      </Toolbar>
    </Paper>
  );
}
Header.Elements = HeaderElements;

export default Header;
